import { useTranslation } from "react-i18next";
import classes from "./ReleaseActivityPage.module.css";
import React from "react";
import { POLL_TYPE, VIEW_ALL_ACTIVITIES_TEXT } from "../../utils/constants";
import YuJaButton from "../../components/standardization/YuJaButton";
import {useHistory, useParams} from "react-router-dom";
import {useLocalStorageNew} from "../../hooks/useLocalStorageNew";
import {removePrefix} from "../../utils/helpers";

export default function ViewInvalidActivity({pollData}) {
    const { t } = useTranslation();
    const { pollKey, pollCode } = useParams();
    const history = useHistory();
    const [, getSession] = useLocalStorageNew("session", {});
    const session = getSession();
    const {gradedLink = false, userId="" } = session;
    const {poll, questions} = pollData;




    return (
        <div className={classes.parentContainer}>
            <div className={classes.mainCard} style={{alignItems: "center"}}>
                <span style={{flex: 1}}/>
                <span className={classes.title} style={{fontSize: 20, lineHeight: 1.4,}}>
                    {t("poll.invalidActivity")}
                </span>
                <span className={classes.description}>

                    {(!poll || !questions || poll.active === "2") &&
                        t("poll.deprecatedPollTitle")
                    }


                    {poll?.pollType !== POLL_TYPE.MERGED_POLL && poll?.pollType !== POLL_TYPE.ATTENDANCE &&
                        t("poll.invalidActivityDesc")
                    }

                    {removePrefix(poll.index1Pk) !== userId &&
                        t("poll.noAccessToActivity")
                    }

                </span>

                <div style={{
                    maxWidth: "100%",
                    width: 500,
                    height: 200,
                    marginTop: 20,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    background: "#D9D9D9"
                }}>
                    <span style={{fontSize: 70, lineHeight: 1.4,}}>{"GIF"}</span>
                </div>

                <span style={{flex: 2}}/>
            </div>
        </div>
    );
}